<script>
/**
 * @Author: zuokangsheng
 * @Date:   2021-11-16 18:46:29
 * @Last Modified by:   zuokangsheng
 * @Last Modified time: 2021-11-17 17:09:25
 */
</script>
<template>
  <div class="index">欢迎进入商家中心。</div>
</template>
<script>
export default {};
</script>
<style lang="scss"></style>
